import get from 'lodash/get';
import BaseModel from '../../common/models/base.model';

class Company extends BaseModel {
  schema = {
    name: this.yup.string().required(this.requiredText),
    vatId: this.yup.string().required(this.requiredText).length(10, 'NIP musi zawierać 10 cyfr'),
    active: this.yup.bool().required(this.requiredText),
    type: this.yup.number().integer().required(this.requiredText),
    main_address: this.yup.object().nullable().shape({
      postal_code: this.yup.string().required(this.requiredText),
      locality: this.yup.string().required(this.requiredText),
      route: this.yup.string().required(this.requiredText),
      street_number: this.yup.string().required(this.requiredText),
      voivodeship: this.yup.string().nullable().required(this.requiredText),
    }),
    group: this.yup.object().required(this.requiredText),
  }

  getData() {
    const main_address = get(this.data, 'main_address.voivodeship.id', false);
    const corespondence_address = get(this.data, 'corespondence_address.voivodeship.id', false);
    const data = {
      ...this.data,
    };

    if (main_address) {
      Object.assign(data, {
        main_address: {
          ...this.data.main_address,
          voivodeship: main_address,
          country: 'Poland',
        },
      });

      if (!data.main_address.address) {
        Object.assign(data, {
          main_address: {
            ...data.main_address,
            address: `${get(data, 'main_address.route')} ${get(data, 'main_address.street_number')}, ${get(data, 'main_address.postal_code')}, ${get(data, 'main_address.locality')}`,
          },
        });
      }
    }

    if (corespondence_address) {
      Object.assign(data, {
        corespondence_address: {
          ...this.data.corespondence_address,
          voivodeship: corespondence_address,
          country: 'Poland',
        },
      });

      if (!data.corespondence_address.address) {
        Object.assign(data, {
          corespondence_address: {
            ...data.corespondence_address,
            address: `${get(data, 'corespondence_address.route')} ${get(data, 'corespondence_address.street_number')}, ${get(data, 'corespondence_address.postal_code')}, ${get(data, 'corespondence_address.locality')}`,
          },
        });
      }
    }

    return data;
  }
}

export default Company;
